import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { ServiceProviderFull } from '@/services/providerService';

// This hook fetches the FULL provider profile including PII
// It should ONLY be used for the provider's own dashboard
export const useProviderProfile = (userId?: string) => {
  return useQuery({
    queryKey: ['provider-profile', userId],
    queryFn: async () => {
      if (!userId) throw new Error('User ID required');

      // Providers can view their own full record via RLS policy
      const { data, error } = await supabase
        .from('service_providers')
        .select('*')
        .eq('user_id', userId)
        .single();

      if (error) {
        if (error.code === 'PGRST116') {
          // No provider found
          return null;
        }
        throw error;
      }

      return data as unknown as ServiceProviderFull;
    },
    enabled: !!userId,
  });
};
